import EventDispatcher from '../base/events/EventDispatcher';

const getGlobalTime = () => Date.now() * 0.001;

class Ticker extends EventDispatcher {
    _isPlaying = false;

    _startTime = -1;

    _pauseTime = -1;

    _pausesDuration = 0;

    _time = 0;

    _delta = 0;

    static EVENT_TICK = 'tick';

    get isPlaying() {
        return this._isPlaying;
    }

    get time() {
        // Except pauses duration to prevent jumps
        return this._time - this._startTime - this._pausesDuration;
    }

    get delta() {
        return this._delta;
    }

    start() {
        if (this._isPlaying) return;
        const t = getGlobalTime();

        if (this._startTime < 0) {
            this._startTime = t;
            this._delta = 0;
        }

        if (this._pauseTime > -1) {
            this._pausesDuration += t - this._pauseTime;
        }

        const onTick = () => {
            if (!this._isPlaying) return;

            const newT = getGlobalTime();

            this._delta = newT - this._time;
            this._time = newT;

            this.dispatchEvent({ type: Ticker.EVENT_TICK, time: this.time, delta: this.delta });

            requestAnimationFrame(onTick);
        };

        this._time = t;
        this._isPlaying = true;

        requestAnimationFrame(onTick);
    }

    pause() {
        if (!this._isPlaying) return;

        this._pauseTime = getGlobalTime();
        this._isPlaying = false;
    }

    reset() {
        this._startTime = -1;
        this._pauseTime = -1;
        this._pausesDuration = 0;
        this._time = 0;
        this._delta = 0;
    }
}

export default Ticker;

let instance = null;

export const getGlobalTicker = () => {
    instance = instance || new Ticker();

    return instance;
};
